import axios from 'axios';
import { API_HOST } from '../config.env';
import { isDemo } from '../helpers';
import { addAction as addActionDemos, edit as editDemos } from './demos';

const headers = access => {
    return {
        headers: {
            Accept: 'application/ld+json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${access}`
        }
    }
}

export const create = (maNo, homeTeam, awayTeam, matchDate, access) => {
    return axios.post(`${API_HOST}/api/lives`, {
        matchId: parseInt(maNo),
        homeTeam,
        awayTeam,
        matchDate 
    }, headers(access));
}

export const edit = (id, bodyRequest, access) => {
    if(isDemo(id)) {
        return new Promise((resolve, reject) => {
            resolve({data: editDemos(bodyRequest)})
        })
    }
    return axios.put(`${API_HOST}/api/lives/${id}`, bodyRequest, headers(access));
}

export const addAction = (live, body, access) => {
    if(isDemo(live)) {
        return new Promise((resolve, reject) => {
            resolve({data: addActionDemos(body)})
        })
    }
    return axios.post(`${API_HOST}/api/lives/${live}/add_action`, body, headers(access));
}